import { FC } from 'react'
import styled from 'styled-components'
import { PaymentMethodTypeKorean } from '@/constants/legacy/constData'
import { PaymentMethodTypeEnum } from '@/constants/payment-method-type.enum'
import { PaymentMethodsWithBenefit } from '@/types/payment-method-benefit.type'

type PaymentBenefitTextProps = {
  paymentMethodsWithBenefit: PaymentMethodsWithBenefit[]
  selectedMethod: PaymentMethodTypeEnum
}

// 혜택 내용 영역
const PaymentBenefitText: FC<PaymentBenefitTextProps> = ({ paymentMethodsWithBenefit, selectedMethod }) => {
  const selectedPaymentMethodWithBenefit = paymentMethodsWithBenefit.find((item) => item.method === selectedMethod)
  if (!selectedPaymentMethodWithBenefit) {
    return null
  }

  const { method, benefit } = selectedPaymentMethodWithBenefit
  // 현재 선택된 결제수단에 대한 혜택 내용이 없으면 null 반환
  if (!benefit.contents) {
    return null
  }

  return (
    <>
      <StyledTitle>
        <BenefitMark>혜택</BenefitMark>
        {PaymentMethodTypeKorean[method]}
      </StyledTitle>
      <StyledBody>
        {benefit.contents?.map(({ id, title, description }) => {
          return (
            <StyledBenefitInnerContainer key={id}>
              <StyledDescription>{title}</StyledDescription>
              {description?.split('\n').map((text: string, index) => (
                <StyledSubDescription key={index}>{`· ${text}`}</StyledSubDescription>
              ))}
            </StyledBenefitInnerContainer>
          )
        })}
      </StyledBody>
    </>
  )
}

const StyledTitle = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: 15px;
  line-height: 19px;
  color: ${({ theme }) => theme.color.gray900};
  display: flex;
  align-items: center;
`

const BenefitMark = styled.div`
  background-color: ${({ theme }) => theme.color.red50};
  border-radius: 10px;
  color: ${({ theme }) => theme.color.red500};
  font-size: 11px;
  font-weight: 700;
  width: 31px;
  height: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
`

const StyledBody = styled.div`
  margin-top: 0.4rem;
`

const StyledBenefitInnerContainer = styled.div`
  width: 100%;
  margin-top: 0.8rem;
  padding: 1.6rem;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.gray50};
`

const StyledDescription = styled.div`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.02em;
  font-weight: 600;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.color.gray900};
`

const StyledSubDescription = styled.div`
  font-size: 13px;
  letter-spacing: -0.02em;
  line-height: ${({ theme }) => theme.lineHeight.body5};
  font-weight: 400;
  color: ${({ theme }) => theme.color.gray500};
  margin-bottom: ${({ theme }) => theme.spacing.size4};
`

export default PaymentBenefitText
